import appApi from "@/api/appApi";

export default {
  async getVideos() {
    const { data } = await appApi.get("/vk/video");
    const { data: payload, success } = data;
    let videos;
    if (success) {
      videos = payload.video.items.slice(0, 4);
    }
    return videos;
  },

  async getPartners() {
    const { data } = await appApi.get("/blocks/all?positions[0]=5&type=2");
    if (data.success) {
      data.data = data.data[5];
    }
    return data;
  }
};
